import { render, staticRenderFns } from "./PdfViewerStateBanner.vue?vue&type=template&id=c12d1296&scoped=true"
import script from "./PdfViewerStateBanner.vue?vue&type=script&lang=js"
export * from "./PdfViewerStateBanner.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerStateBanner.vue?vue&type=style&index=0&id=c12d1296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d1296",
  null
  
)

export default component.exports